import type { Project } from '#auth/composables/useAuth'
import { ref } from '#imports'

export type SelectProjectModalOutcome =
  | { type: 'select', project: Project }
  | { type: 'dashboard' }

const isOpen = ref(false)
let lastOutcome: SelectProjectModalOutcome | null = null

export function useSelectProjectModal() {
  function open() {
    lastOutcome = null
    isOpen.value = true
  }

  function selectProject(project: Project) {
    lastOutcome = { type: 'select', project }
    isOpen.value = false
  }

  function goToDashboard() {
    lastOutcome = { type: 'dashboard' }
    isOpen.value = false
  }

  function close() {
    isOpen.value = false
  }

  function consumeOutcome(): SelectProjectModalOutcome | null {
    const outcome = lastOutcome
    lastOutcome = null
    return outcome
  }

  return {
    isOpen,
    open,
    selectProject,
    goToDashboard,
    close,
    consumeOutcome,
  }
}
